<script setup></script>
<template>
  <div style="display: flex; flex-direction: row; align-items: center">
    <slot></slot>
  </div>
</template>
<style scoped></style>
